package team.platforma.aicombo.activity.main.component.profile.fragment

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.Button
import androidx.compose.material3.Text
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import team.platforma.aicombo.activity.chat.ChatActivity
import team.platforma.extra_nav.component.fragment_component.Fragment
import team.platforma.extra_nav.navigator.activity.findNavHost

object ProfileFragment : Fragment(
    route = "profile_fragment",
    fragmentBox = { componentNavigator, fragmentNavigator, paddingValues ->
        Column(
            modifier = Modifier.fillMaxSize(),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Text(
                text = "ProfileFragment"
            )
            Button(onClick = { findNavHost().navigateToActivity(ChatActivity) }){
                Text(text = "Go to chat")
            }
        }
    }
)